<template>
  <div class="index">
    <div class="content">
      <div class="num">
        <p>
          修改用户头像 <img v-if="userInfo.avatarurl" :src="userInfo.avatarurl" alt="" />
          <img v-else src="../../../static/user.png" alt="" />
        </p>
        <el-upload
          class="avatar-uploader"
          action="http://101.43.7.138:85/api/common/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="num">
        <p>
          更换手机号码
          <span v-if="userInfo.phone" style="margin-left: 20px">{{
            userInfo.phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
          }}</span>
        </p>
        <el-button type="text" @click="dialogFormVisible = true">修改</el-button>
        <el-dialog title="修改手机" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="手机号码" :label-width="formLabelWidth">
              <el-input
                v-model="form.phone"
                autocomplete="off"
                placeholder="请输入手机号码"
              ></el-input>
            </el-form-item>
            <el-form-item label="验证码" :label-width="formLabelWidth">
              <el-input
                v-model="form.code"
                autocomplete="off"
                placeholder="请输入验证码"
              ></el-input>
              <span
                ref="code"
                style="margin-left: 20px; cursor: pointer"
                @click="getCode"
              >
                获取验证码
              </span>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelPhone">取 消</el-button>
            <el-button type="primary" @click="changePhone">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="num">
        <p>修改密码 <span style="margin-left: 20px">********</span></p>
        <el-button type="text" @click="dialogVisible = true">修改</el-button>
        <el-dialog title="修改密码" width="40%" :visible.sync="dialogVisible">
          <div class="password">
            <span>旧密码</span>
            <input type="password" placeholder="请输入旧密码" v-model="oldPassword" />
          </div>
          <div class="password">
            <span>新密码</span>
            <input
              type="password"
              placeholder="请输入新密码(必须同时包含字母和数字,长度>8)"
              v-model="password"
            />
          </div>
          <div class="password">
            <span style="margin-right: 44px">确认密码</span>
            <input
              type="password"
              ref="code"
              placeholder="请再次输入新密码"
              v-model="againPassword"
            />
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelPassword">取 消</el-button>
            <el-button type="primary" @click="changePassword">确 定</el-button>
          </span>
        </el-dialog>
      </div>
      <div class="num">
        <p>
          修改企业名称 <span style="margin-left: 20px">{{ userInfo.company_name }}</span>
        </p>
        <el-button type="text" @click="changeCompanyName">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCodeAPI,
  updatePhone,
  updatePassword,
  updateCompanyName,
  updateAvatar,
  getUserInfo,
} from "@/api/index";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: "120px",
      form: {
        phone: "",
        code: "",
      },
      oldPassword: "",
      password: "",
      againPassword: "",
      time: 60,
      imageUrl: localStorage.getItem("userInfo").avatarurl,
      userInfo: {},
    };
  },
  mounted() {
    this.checkInfo();
  },
  methods: {
    checkInfo() {
      getUserInfo({
        token: localStorage.getItem("token"),
      }).then((res) => {
        this.userInfo = res.data.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      });
    },
    getCode() {
      let timer = null;
      if (!this.form.phone) {
        this.$message.error("手机号不能为空");
        return;
      }
      let data = {
        phone: this.form.phone,
        type: "updatephone",
      };
      if (this.time == 60) {
        getCodeAPI(data).then((res) => {
          this.$message.success(res.data.msg);
          timer = setInterval(() => {
            this.time--;
            this.$refs.code.textContent = this.time + "s后重试";
            if (this.time == 0) {
              this.$refs.code.textContent = "获取验证码";
              this.time = 60;
              clearInterval(timer);
            }
          }, 1000);
        });
      }
    },
    cancelPhone() {
      this.form.phone = "";
      this.form.code = "";
      this.dialogFormVisible = false;
    },
    cancelPassword() {
      this.dialogVisible = false;
      this.oldPassword = "";
      this.password = "";
      this.againPassword = "";
    },
    async changePhone() {
      let data = { token: localStorage.getItem("token") };
      data.phone = this.form.phone;
      data.code = this.form.code;
      await updatePhone(data).then((res) => {
        this.$message.success(res.data.msg);
        this.cancelPhone();
        this.checkInfo();
      });
    },
    async changePassword() {
      let data = { token: localStorage.getItem("token") };
      let validationStr = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;
      if (!validationStr.test(this.password)) {
        this.$message.error("新密码不符合要求");
        return;
      }
      if (this.password !== this.againPassword) {
        this.$message.error("两次密码不一致");
        return;
      }
      data.old_pass = this.oldPassword;
      data.new_pass = this.password;
      await updatePassword(data).then((res) => {
        this.$message.success(res.data.msg);
        this.cancelPassword();
        this.checkInfo();
      });
    },
    async changeCompanyName() {
      this.$prompt("企业名称", "修改企业名称", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let data = { token: localStorage.getItem("token") };
          data.company_name = value;
          updateCompanyName(data).then((res) => {
            this.$message.success(res.data.msg);
            this.checkInfo();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.code == 0) {
        this.$message.error(res.msg);
        return;
      }
      this.imageUrl = URL.createObjectURL(file.raw);
      let data = {
        token: localStorage.getItem("token"),
        avatar: res.data.url,
      };
      updateAvatar(data).then((res) => {
        this.$message.success(res.data.msg);
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>

<style lang="less" scoped>
.el-card__body,
.el-main {
  padding: 0px;
}
.content {
  // height: 350px;
  box-sizing: border-box;
  background-color: #fff;
  margin: 0 20px;
  padding: 20px;
  .num {
    height: 100px;
    line-height: 100px;
    background-color: #f9f9f9;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 20px;
    p {
      display: flex;
      align-items: center;
    }
    img {
      width: 50px;
      height: 50px;
      margin-left: 20px;
      overflow: hidden;
      border-radius: 50%;
    }
    button {
      height: 40px;
      margin-top: 30px;
      width: 60px;
      // background-color: #ecf5ff;
      // color: #93e2ff;
      // border: 1px solid #b3d8ff;
      border-radius: 6px;
    }
    .el-dialog {
      width: 30%;
      .password {
        height: 60px;
        line-height: 60px;
        text-align: left;
        span {
          width: 120px;
          margin-right: 60px;
          font-size: 16px;
        }
        input {
          height: 40px;
          width: 400px;
          border: 1px solid rgb(232, 231, 231);
          outline: none;
          padding-left: 10px;
        }
      }
      .dialog-footer {
        .el-button {
          padding: 0;
        }
      }
    }
  }
}
/deep/.el-input {
  flex: 1;
}
/deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #fff;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #fff;
}
.avatar-uploader {
  display: flex;
  align-items: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.avatar {
  width: 60px;
  height: 60px;
  display: block;
}
</style>
